import { ContactPersonDto } from 'app/_mapper/contactperson.dto';
import { ContactPerson } from 'app/_models/contact-person.model';
// AutoMapper
import "reflect-metadata";
import {
    AutoMapper,
    ProfileBase,
    mapFrom,
    Mapper,
    convertUsing,
    Converter
} from "@nartc/automapper";

// Models
import { InsureeDto } from 'app/_mapper/insuree.dto';
import { InsureeVm } from 'app/_mapper/insuree.vm';

export class InsureeProfile extends ProfileBase {
    constructor(mapper: AutoMapper) {
        super();

        mapper
            .createMap(InsureeDto, InsureeVm)
            .forMember(
                d => d.ipaBsnCitizenServiceNumber,
                mapFrom(s => s.bsn))
            .forMember(
                d => d.ipaInitials,
                mapFrom(s => s.initials))
            .forMember(
                d => d.ipaFirstName,
                mapFrom(s => s.firstName))
            .forMember(
                d => d.ipaLastName,
                mapFrom(s => s.lastName))
            .forMember(
                d => d.ipaMaidenName,
                mapFrom(s => s.maidenName))
            .forMember(
                d => d.ipaStreetName,
                mapFrom(s => s.streetName))
            .forMember(
                d => d.ipaHouseNumber,
                mapFrom(s => s.houseNumber))
            .forMember(
                d => d.ipaHouseNumberAddition,
                mapFrom(s => s.houseNumberAddition))
            .forMember(
                d => d.ipaPostalCode,
                mapFrom(s => s.postalCode))
            .forMember(
                d => d.ipaCity,
                mapFrom(s => s.city))
            .forMember(
                d => d.country.id,
                mapFrom(s => s.countryId))
            .forMember(
                d => d.ipaPhoneNumber,
                mapFrom(s => s.phoneNumber))
            .forMember(
                d => d.ipaPhoneNumber2,
                mapFrom(s => s.phoneNumber2))
            .forMember(
                d => d.ipaEmail,
                mapFrom(s => s.email))
            .forMember(
                d => d.ipaDateOfBirth,
                mapFrom(s => new Date(s.dateOfBirth)))
            // .forMember(
            //     d => d.gender,
            //     mapFrom(s => s.gender??))
            .forMember(
                d => d.ipaRemarks,
                mapFrom(s => s.remarks))
            .forMember(
                d => d.ipaContactInitiation,
                mapFrom(s => s.contactInitiationId))
            .forMember(
                d => d.ipaContactWith,
                mapFrom(s => s.contactWithId))
            .forMember(
                d => d.ipaContactTelephone,
                mapFrom(s => s.contactInitiationPhone))
            ;

        mapper
            .createMap(InsureeVm, InsureeDto)
            .forMember(
                d => d.bsn,
                mapFrom(s => s.ipaBsnCitizenServiceNumber))
            .forMember(
                d => d.initials,
                mapFrom(s => s.ipaInitials))
            .forMember(
                d => d.firstName,
                mapFrom(s => s.ipaFirstName))
            .forMember(
                d => d.lastName,
                mapFrom(s => s.ipaLastName))
            .forMember(
                d => d.maidenName,
                mapFrom(s => s.ipaMaidenName))
            .forMember(
                d => d.streetName,
                mapFrom(s => s.ipaStreetName))
            .forMember(
                d => d.houseNumber,
                mapFrom(s => s.ipaHouseNumber))
            .forMember(
                d => d.houseNumberAddition,
                mapFrom(s => s.ipaHouseNumberAddition))
            .forMember(
                d => d.postalCode,
                mapFrom(s => s.ipaPostalCode))
            .forMember(
                d => d.city,
                mapFrom(s => s.ipaCity))
            .forMember(
                d => d.countryId,
                mapFrom(s => s.country.id))
            .forMember(
                d => d.phoneNumber,
                mapFrom(s => s.ipaPhoneNumber))
            .forMember(
                d => d.phoneNumber2,
                mapFrom(s => s.ipaPhoneNumber2))
            .forMember(
                d => d.email,
                mapFrom(s => s.ipaEmail))
            .forMember(
                d => d.dateOfBirth,
                mapFrom(s => s.ipaDateOfBirth.toUTCString()))
            .forMember(
                d => d.gender,
                mapFrom(s => s.ipaPartyGender.id.toString()))
            .forMember(
                d => d.remarks,
                mapFrom(s => s.ipaRemarks))
            .forMember(
                d => d.contactInitiationId,
                mapFrom(s => s.ipaContactInitiation))
            .forMember(
                d => d.contactWithId,
                mapFrom(s => s.ipaContactWith))
            .forMember(
                d => d.contactInitiationPhone,
                mapFrom(s => s.ipaContactTelephone))
            .forMember(
                d => d.contactPersons,
                mapFrom(s => s.ContactPersons.map(cp => new ContactPersonDto())))
            ;
    }
}
